
// if true - higher is better, if false - lower is better
const getValue = (vehicle: any, key: string) => {
  if (key === 'business' && vehicle?.lease_data?.business?.monthly_net) {
    return vehicle.lease_data.business.monthly_net;
  }
  
  return vehicle[key];
}

export function compareValues(vehicles: any[], key: string, criteria: boolean) { 
  let best_value = getValue(vehicles[0], key), index = 0;

  for (let i = 1; i < vehicles.length; i++) {
    const value = getValue(vehicles[i], key)

    // if there are at least two same values in the array - there is no need to highlight the best one
    if (value === best_value) { 
      index = -1;
      break;
    }
    
    if (criteria) {
      if (value > best_value && value > 0) {
        best_value = value;
        index = i;
      }
    }
    else {
      if (value < best_value && value > 0) {
        best_value = value;
        index = i;
      }
    }
  }

  return index;
}

export function highlightLowest(vehicles: any[], key: string) {
  return compareValues(vehicles, key, false);
}

export function highlightHighest(vehicles: any[], key: string) {
  return compareValues(vehicles, key, true);
}
